/**
 *
 * Asynchronously loads the component for Webhooks
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
